const NoMatch = () => {
  return (
    <section className="section">
      <div className="container">404</div>
    </section>
  );
};

export default NoMatch;
